import { useCallback } from 'react';
import trackEvent from 'analytics/posthog/trackEvent';
import type { EventProperties } from 'analytics/posthog/types';

const useTrackEvent = () => {
    const track = useCallback(
        (
            eventName: string,
            properties?: EventProperties,
        ) => trackEvent(eventName, properties),
        [],
    );

    return { track };
};

export default useTrackEvent;
